export default "__VITE_ASSET__DrbK1ylh__"